import $ from 'jquery';

class Select {
  constructor(options) {
    const defaultOptions = {
      selector: "select",
      customSelectClassName: "select",
      customSelectActiveClassName: "select--open",
      currentClassName: "select__current",
      selectListClassName: "select__list",
      selectListUlClassName: "select__list--holder",
      selectItemClassName: "select__item",
      activeItemClass: "select__item--active",
      disableItemClass: "select__item--disabled",
      activeClass: "select--open",
      event: "click",
      onChange(/* select */) {
        // select onChange event
      }
    };
    this.options = {
      ...defaultOptions,
      ...options
    };

    return this.init(this.options.selector);
  }
  init(selector) {
    const selects = document.querySelectorAll(selector);
    if (!selects) return;
    selects.forEach(element => {
      const customSelect = this.renderSelect(element);
      element.parentNode.insertBefore(customSelect, element.nextSibling);
    });

  }
  update(selector) {
    const selects = $(`select${selector}`);
    if (!selects) return;
    selects.each((key, select) => {
      const nextElement = $(select).next('div.select');
      nextElement.remove();
    });
    
    
    this.init(selector);
  }
  renderSelect(select) {
    const currentElement = document.createElement("span");
    const currentElementText = document.createElement("span");
    const customSelectList = document.createElement("div");
    const customSelectListHolder = document.createElement("ul");
    const customSelect = document.createElement("div");
    const nativeSelectClasses = select.className.trim().split(" ");
    // add classes to custm select
    customSelect.classList.add(this.options.customSelectClassName);
    if (select.className) {
      customSelect.classList.add(...nativeSelectClasses);
    }

    // add tabindex if it exist
    if (select.getAttribute("tabindex")) {
      customSelect.setAttribute("tabindex", select.getAttribute("tabindex"));
    }
    // add disabled class if it exist
    if (select.disabled) {
      customSelect.classList.add("disabled");
    }
    
    customSelectListHolder.classList.add(this.options.selectListUlClassName);
    currentElement.classList.add(this.options.currentClassName);
    customSelectList.classList.add(this.options.selectListClassName);

    currentElement.appendChild(currentElementText);
    customSelectList.appendChild(customSelectListHolder);
    customSelect.appendChild(currentElement);
    customSelect.appendChild(customSelectList);

    const options = select.querySelectorAll("option");
    const selected =
      select.querySelector("option:checked") ||
      select.querySelector("option:first-child");
    // set current
    const currentText =
      selected.getAttribute("data-display") || selected.innerText;
    currentElement.querySelector('span').innerText = currentText;

    // build list
    options.forEach(option => {
      const display = option.getAttribute("data-display");
      const nativeOptionClasses = option.className.trim().split(" ");
      const item = document.createElement("li");
      item.classList.add(this.options.selectItemClassName);

      if (option.className) {
        item.classList.add(...nativeOptionClasses);
      }

      if (option.selected) {
        item.classList.add(this.options.activeItemClass);
      }

      if (option.disabled) {
        item.classList.add(this.options.disableItemClass);
      }

      item.setAttribute("data-value", option.value);
      item.innerText = display || option.innerText;
      customSelectListHolder.appendChild(item);
    });

    this.addListeners(select, customSelect);

    return customSelect;
  }
  addListeners(select, customSelect) {
    const { options } = this;

    select.addEventListener("change", function onChangeHandler() {
      if (typeof options.onChange === "function") {
        options.onChange(this);
      }
    });

    const close = function closeEvent(){
      customSelect.classList.remove(options.customSelectActiveClassName);
    }

    const documentHandler = event => {
      if (!event.target.classList.contains(options.selector) && !event.target.classList.contains(options.currentClassName)){
        close();
        document.removeEventListener('click', documentHandler, false);
      }
    };

    const open = function openEvent (element){
      element.classList.add(options.customSelectActiveClassName);
      document.addEventListener('click', documentHandler, false);
      
      $('div.select').not(element).removeClass(options.customSelectActiveClassName);
    }
    customSelect.addEventListener("click", function onClickHandler() {
      if(!this.classList.contains(options.customSelectActiveClassName)){
        open(this);
      }else{
        close();
      }
    });

    const optionsList = customSelect.getElementsByClassName(
      options.selectItemClassName
    );
    const currentElement = customSelect.getElementsByClassName(
      options.currentClassName
    )[0];
    const naviveOptions = select.querySelectorAll("option");

    Array.prototype.forEach.call(optionsList, item => {
      item.addEventListener("click", function onClickHandler(event) {
        if (this.classList.contains(options.activeItemClass)) {
          return;
        }

        if (this.classList.contains(options.disableItemClass)) {
          event.stopPropagation();
          return;
        }
        const index = Array.prototype.indexOf.call(
          this.parentElement.children,
          this
        );

        Array.prototype.forEach.call(
          customSelect.getElementsByClassName(options.selectItemClassName),
          element => {
            element.classList.remove(options.activeItemClass);
          }
        );

        currentElement.querySelector('span').innerText = this.innerText;
        this.classList.add(options.activeItemClass);

        // change select value
        select.setAttribute("value", this.getAttribute("data-value"));
        naviveOptions.forEach(nativeItem => {
          $(nativeItem).removeAttr('selected');
        });
        naviveOptions[index].setAttribute('selected',true);
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }
}

export default Select;
